import React from "react";
import { RiLogoutBoxRLine } from "react-icons/ri";
import { useGlobalContext } from "../../Context/GlobalContext";
import ShowToastMsg from "../../Extra/ShowToastMsg";
import { FaIdCardAlt } from "react-icons/fa";
const LogOut = () => {
  const { userData, setUserData } = useGlobalContext();
  const handleClick = () => {
    setUserData(null);
    localStorage.removeItem("token");

    ShowToastMsg({
      type: "success",
      toastText: `Logged out successfully`,
      duration: 4000,
    });
  };

  return (
    <div className="d-flex justify-content-end">
      {" "}
      <button
        className="btn btn-sm btn-outline-danger m-1"
        onClick={handleClick}
      >
        log-out <RiLogoutBoxRLine />
      </button>
    </div>
  );
};
export default LogOut;
